import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Scissors, Palette, SparkleIcon, Crown } from "lucide-react";

const Services = () => {
  const services = [
    {
      title: "Coupes & Coiffures",
      description: "Des coupes personnalisées adaptées à votre visage et votre style de vie.",
      price: "À partir de 35€",
      icon: Scissors,
    },
    {
      title: "Colorations",
      description: "Une large gamme de colorations pour sublimer votre chevelure.",
      price: "À partir de 45€",
      icon: Palette,
    },
    {
      title: "Soins Profonds",
      description: "Des soins sur-mesure pour des cheveux sains et brillants.",
      price: "À partir de 25€",
      icon: SparkleIcon,
    },
    {
      title: "Coiffures de Mariage",
      description: "Des coiffures élégantes pour votre grand jour.",
      price: "Sur devis",
      icon: Crown,
    },
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="pt-16">
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-bold text-center text-gray-900 mb-12">
              Nos Services
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mr-4">
                      <service.icon className="w-6 h-6 text-pink-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">{service.title}</h3>
                  </div>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <p className="text-pink-600 font-semibold">{service.price}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Services;